<template>
  <div class="con">
    <span class="to-top" @click="scrollToTop"><PhBoldCaretUp /></span>
  </div>
</template>

<script>
import { PhBoldCaretUp } from "@kalimahapps/vue-icons";
export default {
  components: {
    PhBoldCaretUp,
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.con {
  width: 100%;
  padding: 2rem 0;
  background-color: transparent;
}
/* body.dark .con {
  background-color: #13323a;
} */
span.to-top {
  margin: 0 auto;
  cursor: pointer;
  background-color: #2b4239;
  color: #ffffff;
  font-size: 1.5rem;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 4px 0px #00000040;
  transition: all 0.3s ease-in-out;
}
span.to-top:hover {
  background-color: #dad2c5;
  color: #0d0d0d;
}
</style>
